import styled from 'styled-components';
import { rem } from 'polished';
// import mediaqueries from '../../../config/themes/variables/mediaqueries';
import { Rotate360 } from '../../../../utils/animations';
import Icon from '../../../core/Icon';

export const StyleError = styled.div`
  text-align: center;
`;

export const StyleErrorText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('15px')};
  margin: ${rem('2px')} 0;
`;

export const StyleUploadText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('12px')};
`;

export const IconAnimated = styled(Icon)`
  animation: ${Rotate360} 2s linear infinite;
  margin: ${rem('15px')} 0 ${rem('10px')};
`;
